import { getAuthToken } from "api/authToken";

const BACK_URL = process.env.REACT_APP_APP_BACK_URL;

const triggerBrowserDownload = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const streamingDownload = async ({
  path,
  fileName,
  mimeType,
  onProgress,
  signal,
}) => {
  const token = getAuthToken();
  const response = await fetch(`${BACK_URL}${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    signal,
  });

  // Mirror the axios interceptor's global 401 handling.
  if (response.status === 401) {
    localStorage.clear();
    window.location.href = "/login";
    return;
  }
  if (!response.ok) {
    throw new Error(`Download failed with status ${response.status}`);
  }

  // Browsers without a streaming body: fall back to a single buffered blob.
  if (!response.body) {
    triggerBrowserDownload(await response.blob(), fileName);
    return;
  }

  const total = Number(response.headers.get("Content-Length")) || 0;
  const reader = response.body.getReader();
  const chunks = [];
  let received = 0;
  let lastPercent = -1;

  // Reading a stream is inherently sequential: each read must await the
  // previous one, so the per-chunk await cannot be parallelized away.
  /* eslint-disable no-await-in-loop */
  let chunk = await reader.read();
  while (!chunk.done) {
    chunks.push(chunk.value);
    received += chunk.value.byteLength;
    if (total && onProgress) {
      const percent = Math.round((received / total) * 100);
      if (percent !== lastPercent) {
        lastPercent = percent;
        onProgress(percent);
      }
    }
    chunk = await reader.read();
  }
  /* eslint-enable no-await-in-loop */

  const blob = new Blob(chunks, mimeType ? { type: mimeType } : undefined);
  triggerBrowserDownload(blob, fileName);
};
